var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeetingTimeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1701 15.8332C13.3917 15.8332 16.0034 13.2215 16.0034 9.99984C16.0034 6.77818 13.3917 4.1665 10.1701 4.1665C6.9484 4.1665 4.33673 6.77818 4.33673 9.99984C4.33673 13.2215 6.9484 15.8332 10.1701 15.8332Z",
    stroke: "#4B5563",
    strokeWidth: 1.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.14089 2.61328C4.57556 2.76469 4.06005 3.06227 3.64622 3.47611C3.23238 3.88995 2.9348 4.40545 2.78339 4.97078M15.1992 2.61328C15.7645 2.76469 16.2801 3.06227 16.6939 3.47611C17.1077 3.88995 17.4053 4.40545 17.5567 4.97078M10.1701 6.66661V9.79161C10.1701 9.90661 10.2634 9.99995 10.3784 9.99995H12.6701",
    stroke: "#4B5563",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetingTimeIcon);
export default __webpack_public_path__ + "static/media/meeting-time-icon.833167695cfdf71cc621a083e10a52ca.svg";
export { ForwardRef as ReactComponent };